(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ew-price-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ew-price-slider')) {
  customElements.define('ew-price-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const low = this.querySelector('[data-min-number]');
      const high = this.querySelector('[data-max-number]');
      const lowRange = this.querySelector('[data-min-range]');
      const highRange = this.querySelector('[data-max-range]');
      const limit = Number(this.dataset.limit);
      const sync = (source) => {
        let a = Number(source === lowRange ? lowRange.value : low.value);
        let b = Number(source === highRange ? highRange.value : high.value);
        a = Math.max(0, Math.min(limit, Number.isFinite(a) ? a : 0));
        b = Math.max(0, Math.min(limit, Number.isFinite(b) ? b : limit));
        if (a > b) {
          if (source === low || source === lowRange) a = b;
          else b = a;
        }
        low.value = lowRange.value = a;
        high.value = highRange.value = b;
        this.style.setProperty('--low', `${a / limit * 100}%`);
        this.style.setProperty('--high', `${100 - b / limit * 100}%`);
        lowRange.setAttribute('aria-valuetext', `${a.toFixed(2)}`);
        highRange.setAttribute('aria-valuetext', `${b.toFixed(2)}`);
      };
      [lowRange, highRange].forEach(input => input.addEventListener('input', () => sync(input)));
      [low, high].forEach(input => input.addEventListener('change', () => sync(input)));
      form.addEventListener('submit', event => {
        event.preventDefault();
        sync();
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        if (Number(low.value) > 0) url.searchParams.set(this.dataset.minName, low.value);
        else url.searchParams.delete(this.dataset.minName);
        if (Number(high.value) < limit) url.searchParams.set(this.dataset.maxName, high.value);
        else url.searchParams.delete(this.dataset.maxName);
        url.hash = 'ResultsList';
        window.location.assign(url.toString());
      });
      sync();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
